<lib-modal-header (close)="close$.emit()">
  {{ "modals.attendance.continue-prompt" | translate }}
</lib-modal-header>
<lib-modal-body>
  <form [formGroup]="form">
    <lib-form-control>
      <div class="checkbox-container">
        <div class="checkbox-list-item">
          <lib-checkbox formControlName="keepAttendance" (change)="onCheckboxChange('keepAttendance')"></lib-checkbox>
          <span>{{ "modals.attendance.confirm-continue" | translate }}</span>
        </div>
        <div class="checkbox-list-item" *ngIf="isPublicHc">
          <lib-checkbox formControlName="changeHc" (change)="onCheckboxChange('changeHc')"></lib-checkbox>
          <span>{{ "modals.attendance.change-hc" | translate }}</span>
        </div>
        <div class="checkbox-list-item">
          <lib-checkbox formControlName="takeBreak" (change)="onCheckboxChange('takeBreak')"></lib-checkbox>
          <span>{{ "modals.attendance.take-break" | translate }}</span>
        </div>
      </div>
    </lib-form-control>
  </form>
</lib-modal-body>
<lib-modal-footer class="footer">
  <button (click)="confirm()" libButton [appearance]="'primary'">
    {{ "modals.confirm.title" | translate }}
  </button>
</lib-modal-footer>
